// extracted by mini-css-extract-plugin
export var searchHeader = "_9v-0";
export var searchHeaderDark = "_9v-1";